
import { Component, Vue } from "vue-property-decorator";

const BUTTON_PROPS = {
  outline: true,
  small: true,
};

const MESSAGES = {
  button: "Reupload",
};

@Component
export default class UploaderReuploadButton extends Vue {
  BUTTON_PROPS = BUTTON_PROPS;
  MESSAGES = MESSAGES;

  onClick() {
    this.$emit("on-click");
  }
}
